import React, {
  useState, useEffect, useRef
} from 'react'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const getRefHeight = (ref) => {
  if (ref && ref.current) {
    return ref.current.getBoundingClientRect().height
  }
  return 0
}

/**
 * Layout HOC:
 *  - essentially resize a Component containing box to the value of its own height
 *
 * @param WrappedComponent
 * @param heightPercent
 * @return {(function(*): *)|*}
 */
function withRelativeContentHeight(WrappedComponent, heightPercent = 100) {
  let warning

  if (Number.isNaN(heightPercent)) {
    warning = '\'heightPercent\' must be a number.'
  } else if (heightPercent && (heightPercent < 0 || heightPercent > 100)) {
    warning = ('\'heightPercent\' must be between 0-100.')
  }

  if (warning) {
    console.warn(`withRelativeContentHeight() initialisation error, ${warning}`)
    return WrappedComponent
  }

  const WithRelativeContentHeight = (props) => {
    const [adjustedHeight, setAdjustedHeight] = useState(0)
    const innerRef = useRef()

    useEffect(() => {
      const refHeight = getRefHeight(innerRef)
      setAdjustedHeight(heightPercent * 0.01 * refHeight)
      // eslint-disable-next-line react/destructuring-assignment
    }, [props.children])

    const outerStyle = {
      height: `${adjustedHeight}px`
    }

    return (
      <div style={outerStyle}>
        <div ref={innerRef}>
          <WrappedComponent {...props} />
        </div>
      </div>
    )
  }

  WithRelativeContentHeight.displayName = `WithRelativeContentHeight(${getDisplayName(WrappedComponent)})`;
  return WithRelativeContentHeight;
}

export default withRelativeContentHeight
